<template>
  <div class="mission_view_800">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <confirm-dialog ref="confirmSendingOtherCode">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4" style="color: white"
          @click="acceptSendingToOtherCodeConfirmation()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn mx-2"
          @click="cancelSendingOtherCodeConfirmation()">
          خیر
        </v-btn>
        <v-btn elevation="0" small rounded color="grey lighten-3" class="normal-letter-spacing px-10"
          @click="ignoreSendingOtherCodeConfirmation()">
          انصراف
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="bottomListItemsModal" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-office-building</v-icon>
              <span class="modal-title-text mr-2">ستون های نمایشی</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeOtherOrganModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12" v-for="item in bottomListTableHeader" :key="item.id">
              <v-checkbox v-model="item.show" :label="item.text" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="1200" v-model="editModal" persistent>
      <edit800-mission-component v-if="editModal" :missionId="missionId" :missionPhoneId="missionPhoneId"
        :missionCode="missionPhoneCode" :phoneCode="phoneCode" :phoneId="phoneId"></edit800-mission-component>
    </v-dialog>
    <v-dialog v-model="otherOrganModal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-office-building</v-icon>
              <span class="modal-title-text mr-2">سازمان های همکار</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeOtherOrganModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-row>
                <span>درخواست ها و پیشنهادات</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12" v-for="item in allMissionOtherOrganizationRequests" :key="'s' + item.id">
                  <v-card elevation="0" class="other-organ-sugest-card-part">
                    <span class="other-organ-sugest-user">
                      {{ item.user.firstName }} {{ item.user.lastName }}
                    </span>
                    <v-card-text>
                      <v-row>
                        <v-chip small class="mr-2 mt-1 mb-1" v-for="subItem in item.requests" :key="'wi' + subItem.id">
                          {{ subItem.otherOrganization.title }}
                        </v-chip>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span>سازمان های انتخابی</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card height="25vh" elevation="0" class="other-organ-selected-card-part">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete :items="allOtherOrganizationsForOther" no-data-text="اطلاعاتی وجود ندارد"
                            dense outlined item-text="title" item-value="id" label="سازمان همکار" clearable
                            clear-icon="mdi-close-circle-outline" v-model="selectedOtherOrgan" autocomplete="off"
                            prepend-inner-icon="mdi-office-building mdi-18px">
                            <template v-slot:append-outer>
                              <v-btn x-small elevation="0" color="darkColor" class="py-5 mt-n2"
                                @click="addSeletctedOtherOrgan()">
                                <v-icon color="white">mdi-plus mdi-18px</v-icon>
                              </v-btn>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="mt-n10">
                          <v-row>
                            <v-col cols="12" v-for="item in allMissionOtherOrganizationInforms" :key="item.id">
                              <span class="mr-2 mt-2 other-organ-selected-span">
                                {{ item.otherOrganization.title }}
                                <v-icon class="mr-4" @click="deleteMissionOtherOrganizationInformFunction(item.id)">
                                  mdi-close-circle mdi-18px
                                </v-icon>
                              </span>
                              <v-icon color="darkColor" class="mr-2"
                                @click="callToOtherOrgan(item.otherOrganization.phoneNumber)">
                                mdi-phone mdi-flip-h mdi-18px
                              </v-icon>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="attachmentModal" width="750">
      <v-card v-if="attachmentModal">
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">{{ attachmentModalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="کد" rounded outlined dense v-model="searchTextCode_Attach"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="جستجو..." rounded outlined dense v-model="attachmentListSearch"></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <template>
                <v-data-table fixed-header :headers="attachmentCurrentMissionListHeader" :items="attachallFilterList"
                  :items-per-page="attachallFilterList?.length" height="45vh" :hide-default-footer="true"
                  :search="attachmentListSearch" multi-sort class="elevation-0" @click:row="attachmentTableClick">
                  <template v-slot:[`item.check`]="{ item }">
                    <v-checkbox v-if="item.check == true || item.check == false" v-model="item.check"
                      @click="attachmentTableClick(item)" hide-details></v-checkbox>
                  </template>
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" @click="attachMissionBy800UserFunction()" dark rounded
              class="normal-letter-spacing px-12 ml-5">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancelAttachment()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletemodal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-delete</v-icon>
              <span class="modal-title-text mr-2">حذف ماموریت</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allCancelReasonsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="note" item-value="value" label="علل حذف" clearable clear-icon="mdi-close-circle-outline"
                v-model="selectedReason" @change="cancelReasonChanged()" autocomplete="off"
                prepend-inner-icon="mdi-delete mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea outlined label="توضیحات" dense clearable rows="4" clear-icon="mdi-close-circle-outline"
                v-model="removeReason" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="removeMissionBy800UserFunction()" dark rounded
            class="normal-letter-spacing px-12">
            حذف
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelRemoveMission()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendTOPhoneModal" width="1200" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col no-gutters cols="12">
                    <v-icon :class="missionRankIconClass" :color="missionRankIconColor">
                      mdi-car-emergency mdi-18px
                    </v-icon>
                    <span class="mr-1 mt-1 mission-card-header-rank-title">اولویت:</span>
                    <span class="mr-2 mt-1 mission-card-header-rank-text">
                      {{ missionRankText }}
                    </span>
                    <span class="mr-2 mt-1">({{ missionSendInfo.numberOfPatients }} مصدوم)</span>
                  </v-col>
                  <!-- <v-col cols="1" class="flex justify-center">|</v-col> -->

                  <!-- <v-col
                    v-if="missionSendInfo.numberOfPatients"
                    no-gutters
                    cols="8"
                    class=""
                  >
                    <span class="mr-1 mt-1 mission-card-header-rank-title"
                      >تعداد مصدوم:
                    </span>
                    <span class="mr-2 mt-1 mission-card-header-rank-text">
                      {{missionSendInfo.numberOfPatients}} مصدوم</span
                    >
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <span class="modal-title-text mr-2" style="white-space: nowrap;">
                    ماموریت {{ missionSendInfo.lastState ? '(' + missionSendInfo.lastState + ')' : '' }}
                  </span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row no-gutters>
                  <v-col cols="5"></v-col>
                  <v-spacer></v-spacer>
                  <v-tooltip top v-if="sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" color="#212121" v-bind="attrs" v-on="on" @click="showDeleteModal()">
                        mdi-trash-can
                      </v-icon>
                    </template>
                    <span>حذف</span>
                  </v-tooltip>
                  <v-tooltip top v-if="sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" color="#212121" v-bind="attrs" v-on="on" @click="showOtherOrganModal()">
                        mdi-office-building
                      </v-icon>
                    </template>
                    <span>سازمان همکار</span>
                  </v-tooltip>
                  <v-tooltip top v-if="sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" color="#212121" v-bind="attrs" v-on="on" @click="openTerminehModal">
                        mdi-email-arrow-right
                      </v-icon>
                    </template>
                    <span>ترمینه</span>
                  </v-tooltip>
                  <v-tooltip top v-if="sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="openAttachmentModal" class="ml-2" color="#212121" v-bind="attrs" v-on="on">
                        mdi-paperclip
                      </v-icon>
                    </template>
                    <span>پیوست</span>
                  </v-tooltip>
                  <v-tooltip top v-if="missionIsStarred == false && sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#212121" v-bind="attrs" v-on="on" @click="starredMissionBy800UserFunction()">
                        mdi-star-outline
                      </v-icon>
                    </template>
                    <span>ستاره دار کردن</span>
                  </v-tooltip>
                  <v-tooltip top v-if="missionIsStarred == true && sendModalType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#FfD700" v-bind="attrs" v-on="on"
                        @click="removeStarredMissionBy800UserFunction(missionSendInfo?.id)">mdi-star</v-icon>
                    </template>
                    <span>ستاره دار</span>
                  </v-tooltip>
                  <v-divider vertical class="mx-3"></v-divider>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#212121" v-bind="attrs" v-on="on" class="ml-2" @click="closeSendToPhoneModal()">
                        mdi-close
                      </v-icon>
                    </template>
                    <span>بستن</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row class="mt-1">
                <span class="send-mission-title-content2 mr-3">اطلاعات ماموریت</span>
                <v-divider class="mt-3 mr-2"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="8" class="mt-n4">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">آدرس:</span>
                        <span class="mr-2 mt-1 send-mission-info-text-content">
                          {{ missionSendInfo.address }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4" class="mt-n3">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <v-card class="card-info-send-mission" elevation="0" height="5vh">
                        <v-card-text>
                          <v-row>
                            <span class="mt-1 send-mission-info-title-content">شماره تماس:</span>
                            <span class="mr-2 mt-1 x-overflow send-mission-info-text-content">
                              {{
                                missionSendInfo.callerId
                                  ? missionSendInfo.callerId
                                  : missionSendInfo.otherPhoneNumber
                              }}
                            </span>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="1" class="mt-1 mr-1">
                      <v-btn color="darkColor" small class="py-4" block @click="
                        callToPatient(
                          missionSendInfo.callerId
                            ? missionSendInfo.callerId
                            : missionSendInfo.otherPhoneNumber,
                        )
                        ">
                        <v-icon color="white">mdi-phone mdi-18px</v-icon>
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
                <v-col cols="6" class="mt-n3">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">شکایت اصلی:</span>
                        <span class="mr-2 mt-1 x-overflow send-mission-info-text-content">
                          {{
                            missionSendInfo.chiefComplaintText
                              ? missionSendInfo.chiefComplaintText
                              : '-'
                          }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="mt-n3">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">توضیحات شکایت:</span>
                        <span class="mr-2 mt-1 x-overflow send-mission-info-text-content">
                          {{
                            missionSendInfo.chiefComplaintNote
                              ? missionSendInfo.chiefComplaintNote
                              : '-'
                          }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" class="mt-n3">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 ml-2 send-mission-info-title-content">
                          تشخیص احتمالی پرستار:
                        </span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on"
                              class="mt-1 x-overflow send-mission-info-text-content line-clamp-1 missionSendInfo-diagnosis-title">
                              {{
                                missionSendInfo.diagnosis ? missionSendInfo.diagnosis.title : '-'
                              }}
                            </span>
                          </template>
                          <span>
                            {{ missionSendInfo.diagnosis ? missionSendInfo.diagnosis.title : '-' }}
                          </span>
                        </v-tooltip>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="9" class="mt-n3">
                  <v-row>
                    <v-col cols="6">
                      <!--card-info-send-mission-scroll-->
                      <v-card class="card-info-send-mission" elevation="0" height="5vh">
                        <v-card-text>
                          <v-row>
                            <v-col cols="6" class="mt-n2 mr-n3">
                              <span class="send-mission-info-title-content">کدهای پیشنهادی:</span>
                            </v-col>
                            <v-col cols="6" v-if="missionSendInfo.mission115Suggestions">
                              <v-row>
                                <v-chip color="background" x-small class="mt-2"
                                  v-for="(item, index1) in missionSendInfo.mission115Suggestions" :key="'m' + index1">
                                  {{ item.vehicleType.title }} ( {{ item.count }} )
                                </v-chip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <!--card-info-send-mission-scroll-->
                      <v-card class="card-info-send-mission" elevation="0" height="5vh">
                        <v-card-text>
                          <v-row>
                            <v-col cols="4" class="mt-n2 mr-n3">
                              <span class="send-mission-info-title-content">سازمان های همکار:</span>
                            </v-col>
                            <v-col cols="8" v-if="missionSendInfo.missionOtherOrganizationRequests">
                              <v-row>
                                <v-chip color="background" x-small class="mt-2 mr-1"
                                  v-for="(item, index1) in missionSendInfo.missionOtherOrganizationRequests"
                                  :key="'ozq' + index1">
                                  {{ item.otherOrganization.title }}
                                </v-chip>
                                <v-spacer></v-spacer>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="mt-n2">
                  <v-row>
                    <span class="send-mission-title-content2 mr-3">موقعیت</span>
                    <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <!-- <v-text-field
                        rounded
                        placeholder="جستجو..."
                        dense
                        outlined
                        v-model="mapSearchText"
                        v-on:keyup.enter="searchForAddressOnMap()"
                      >
                        <template v-slot:append-outer>
                          <v-btn
                            class="mt-n2"
                            @click="searchForAddressOnMap()"
                            fab
                            small
                            color="darkColor"
                            elevation="0"
                          >
                            <v-icon color="white">mdi-magnify mdi-18px</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field> -->
                      <map-search-field @address-search="onSearchSuggestion" :maxMinSearchProp="false" />
                    </v-col>
                    <v-col cols="12">
                      <!--map-->
                      <div id="map">
                        <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 48vh !important" :zoom="zoom"
                          :center="center" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate"
                          @ready="mapInvalidate()" @click="add800SelectedMarker">
                          <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                          <l-control position="topright">
                            <v-btn icon small tile class="no-letter-space" @click="showHideFence()" style="
                                background-color: white;
                                border: solid;
                                border-width: 2px;
                                border-radius: 5px;
                                border-color: #c2bfba;
                                padding: 15px;
                              ">
                              <v-icon>mdi-layers</v-icon>
                            </v-btn>
                          </l-control>
                          <l-polygon @click="fenceClick($event, item)" v-for="(item, index2) in fence800Coords"
                            :key="'hhk' + index2" :lat-lngs="item.latlngs" :color="item.color" :fillColor="item.color">
                            <v-popup>
                              <span class="ml-12">{{ item.title }}</span>
                              <v-list dense>
                                <v-list-item dense v-for="(lake, index3) in item.moreInfo" :key="'j' + index3"
                                  class="mt-n6">
                                  <v-list-item-title class="text-right">
                                    {{ lake.title }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-popup>
                          </l-polygon>
                          <!-- Marker -->
                          <l-marker style="z-index: 9999999999999999999999999 !important"
                            v-if="patiantPosition && patiantPosition.lat && patiantPosition.lng"
                            :lat-lng.sync="patiantPosition" :icon="patientIcon" visible class="mapIcon">
                            <v-popup>
                              <div class="text-center mb-1">موقعیت مددجو</div>
                              <div class="text-right">
                                {{ address }}
                              </div>
                            </v-popup>
                          </l-marker>
                          <l-marker v-if="
                            selected800Position &&
                            selected800Position.lat &&
                            selected800Position.lng
                          " visible draggable :lat-lng.sync="selected800Position" @dragstart="dragging = true"
                            @dragend="dragging = false"></l-marker>
                          <l-marker ref="marker29" v-for="(item, index4) in allPhoneOnlineLocations" :key="'r' + index4"
                            :lat-lng="[item.latitude, item.longitude]" :icon="getMovingIcon(item)">
                            <l-tooltip :options="{ permanent: true, interactive: true, offset: [-20, 0] }">
                              <div>
                                {{ item?.phone?.code }}
                              </div>
                            </l-tooltip>
                          </l-marker>
                        </l-map>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="mt-2">

                  <v-row>
                    <v-col cols="7" class="m-0">
                      <v-autocomplete hide-details :items="readyPhonesList" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="code" item-value="id" label="کد" clearable :autofocus="true" tabindex="1"
                        clear-icon="mdi-close-circle-outline" autocomplete="off" auto-select-first
                        prepend-inner-icon="mdi-file-document mdi-18px" v-model="selectedPhoneCode"
                        :filter="startsWithFilter">
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item v-bind="attrs" v-on="on" class="custom-autocomplete-item">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="item-code">{{ item.code }}</span>
                                <span class="item-title">{{ item.title }}</span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="5" class="m-0">
                      <v-btn v-if="sendModalType === 'main'" rounded dark tabindex="2" color="darkColor" block
                        @click="sendMissionToPhoneCheckType()">
                        اعزام کد (F9)
                      </v-btn>
                      <v-btn v-else rounded dark tabindex="2" color="darkColor" block
                        @click="sendToOtherCodeConfirmation()">
                        اعزام مجدد کد (F9)
                      </v-btn>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col cols="12">
                      <v-card height="11vh" elevation="0" class="send-mission-detail-card">
                        <v-row no-gutters>
                          <span class="send-mission-title-content">نزدیک ترین کد های پیشنهادی</span>
                        </v-row>
                        <v-card-text class="send-mission-detail-card-body">
                          <v-row v-if="topNearestLoaderFlag == false">
                            <v-chip @click="selectCodeFromAdvice(item)" class="mr-2 mt-2"
                              v-for="(item, index6) in topNearestCodeList" small color="background" :key="'w' + index6">
                              {{ item.code }} -
                              <span style="font-size: 10px">{{ item?.duration?.text ?? '' }}</span>
                            </v-chip>
                          </v-row>
                          <v-row v-else>
                            <v-col cols="12">
                              <v-progress-linear indeterminate color="lightColor" rounded
                                height="8"></v-progress-linear>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card height="11vh" elevation="0" class="send-mission-detail-card">
                        <v-row no-gutters>
                          <span class="send-mission-title-content">
                            کد های پیشنهادی بر اساس فنس
                          </span>
                        </v-row>
                        <v-card-text class="send-mission-detail-card-body">
                          <v-row v-if="topNearestFenceLoaderFlag == false">
                            <v-chip @click="selectCodeFromAdvice(item)" class="mr-2"
                              v-for="(item, index7) in readyPhonesByStationList" small color="background"
                              :key="'ty' + index7">
                              {{ item.code }}
                            </v-chip>
                          </v-row>
                          <v-row v-else>
                            <v-col cols="12">
                              <v-progress-linear indeterminate color="lightColor" rounded
                                height="8"></v-progress-linear>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card height="14vh" elevation="0" class="send-mission-detail-card">
                        <v-row no-gutters>
                          <span class="send-mission-title-content">مناطق فاقد کد</span>
                        </v-row>
                        <v-card-text class="send-mission-detail-card-body">
                          <v-row>
                            <v-col cols="10" class="mt-n5">
                              <v-autocomplete :items="allStationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                                item-text="titleCode" item-value="id" placeholder="انتخاب کد" autocomplete="off"
                                v-model="selectedMissionLakeCode" auto-select-first
                                @keydown.enter="handleEnterLack()"></v-autocomplete>
                            </v-col>
                            <v-col cols="2" class="mt-n4 mr-n4">
                              <v-btn color="darkColor" small class="py-3" block elevation="0"
                                @click="addMissionLakeCode()">
                                <v-icon color="white">mdi-plus mdi-18px</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-chip close close-icon="mdi-close"
                            @click:close="removeCodeFromMissionLakeOfCodeFunction(item.id)" small
                            v-for="(item, index5) in missionSendInfo.missionLackOfCodes" :key="'h' + index5">
                            {{ item.station ? item.station.title : '-' }}
                          </v-chip>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <column-manager-dialog v-model="showColumnManager" :headers="currentHeaders" :defaultHeaders="bottomListTableHeader"
      :fixedValues="['ambulanceCode', 'icon']" @submit="applyNewHeaders" />

    <termineh-modal :is-modal-open="isTerminehModalOpen" :mission-id="missionId"
      :all-universities-list="universitiesList" @close-modal="closeTerminehModal" @on-success="closeSendToPhoneModal" />
    <!-- دیالوگ اصلی ضبط -->
    <v-dialog v-model="showDialog_Voice" width="500px" persistent>
      <v-card class="voiceDialog">
        <v-card-title class="t1">ضبط صدای جدید</v-card-title>

        <v-card-text class="text-center py-4">
          <!-- نمایش تایمر -->
          <div class="text-h4 my-4">{{ formattedTime }}</div>

          <!-- انیمیشن ضبط -->
          <div class="recording-indicator" :class="{ 'is-recording': isRecording }">
            <v-icon size="64" :color="isRecording ? 'red' : 'grey'">mdi-microphone</v-icon>
          </div>

          <!-- کنترلرهای ضبط -->
          <div class="mt-4">
            <v-btn v-if="!isRecording" color="success" @click="startRecording" :loading="isLoading_Voice">
              <v-icon left>mdi-record</v-icon>
              شروع ضبط
            </v-btn>

            <v-btn v-else color="error" @click="stopRecording">
              <v-icon left>mdi-stop</v-icon>
              توقف
            </v-btn>
          </div>

          <!-- نمایش خطا -->
          <v-alert v-if="error_Voice" type="error" dense class="mt-2">{{ error_Voice }}</v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <!-- لیست ویس‌های ذخیره شده -->
        <v-card-title class="t2">لیست پیام‌های صوتی</v-card-title>
        <v-list dense style="max-height: 250px; overflow-y: auto">
          <v-list-item v-for="(voice, index) in voiceList" :key="index" two-line>
            <v-list-item-content>
              <v-list-item-title>
                ویس {{ index + 1 }} ({{ voice.duration }} ثانیه)
              </v-list-item-title>
              <v-list-item-subtitle>{{ voice.date }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click="playVoice(voice)">
                <v-icon color="primary">mdi-play</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="voiceList.length === 0">
            <v-list-item-content class="text-center grey--text">
              ویسی ذخیره نشده است
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showDialog_Voice = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- پخش‌کننده مخفی برای پخش ویس -->
    <audio ref="audioPlayer" @ended="onAudioEnded" style="display: none"></audio>
    <!-- set columns movment -->
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-0 mt-sm-0 mt-md-0 mt-lg-2 mt-xl-2 mt-0 mt-xl-n0">
        <v-row @click="resetSelectedRow">
          <!--top table-->
          <v-col cols="12">
            <v-card elevation="0" class="mission-800-list-card mt-1">
              <v-card-text>
                <v-row class="mb-2">
                  <v-col cols="3" class="covered-position">
                    <span class="current-mission-header-content">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" :color="silentTopListSound ? '#ff0000' : '#464646'" size="16"
                            @click="handleAlarmTopListManual()" v-bind="attrs" v-on="on">
                            {{ silentTopListSound ? 'mdi-bell-off-outline' : 'mdi-bell-outline' }}
                          </v-icon>
                        </template>
                        <span>{{ silentTopListSound ? 'صدای هشدار خاموش' : 'صدای هشدار روشن' }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" :class="{ 'refresh-btn': isTopListLoading }"
                            @click="refreshTopListManual()" v-bind="attrs" v-on="on">
                            mdi-cached mdi-18px
                          </v-icon>
                        </template>
                        <span>به روز رسانی</span>
                      </v-tooltip>
                      ماموریت های جدید
                    </span>
                  </v-col>
                </v-row>
                <template>
                  <v-data-table id="topTable" :headers="currentMission800TopListTableHeader"
                    :items="currentMission800TopList" :items-per-page="currentMission800TopList.length"
                    :height="topTableHight" :item-class="(item) => (item?.iconClass === '10-19' ? 'cancel-style' : '')"
                    dense fixed-header :hide-default-footer="true" multi-sort
                    class="elevation-0 top-table table-top-800" @dblclick:row="showSendToPhoneModal"
                    @click:row="stopSound2">
                    <template v-slot:[`item.icon`]="{ item }">
                      <td>
                        <new-mission-status v-bind="item" @remove-starred-mission-by800-user-function="
                          () => removeStarredMissionBy800UserFunction(item?.id)
                        " />
                      </td>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                      <span>
                        <v-icon class="ml-2">{{ item.locationStateIcon }}</v-icon>
                        {{ item.address }}
                      </span>
                    </template>
                    <template v-slot:[`item.cc`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="truncate" v-bind="attrs" v-on="on">
                            {{ item.cc }}
                          </div>
                        </template>
                        <span>{{ item.cc }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                      <span class="tw-mt-5">اطلاعاتی جهت نمایش وجود ندارد</span>
                    </template>
                  </v-data-table>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="mission-800-list-card">
              <v-card-text class="">
                <div class=" btnContolerBottomList">
                  <div class=" itemBtn">
                    <span class="current-mission-header-content">
                      <v-tooltip left>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-icon id="iconDatabase" class="ml-3" size="16" color="#464646" @click="openColumnManager"
                            v-bind="attrs" v-on="{ ...tooltip }">
                            mdi-database-edit
                          </v-icon>
                        </template>
                        <span>
                          چیدمان جدول
                        </span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" size="16" :color="show1024Flag ? '#464646' : '#ff0000'"
                            @click="toggle1024(!show1024Flag)" v-bind="attrs" v-on="on">
                            {{ show1024Flag ? 'mdi-eye' : 'mdi-eye-off' }}
                          </v-icon>
                        </template>
                        <span>
                          {{ show1024Flag ? ' نمایش کدهای 10-24 موقت' : ' عدم نمایش کدهای 10-24 موقت' }}
                        </span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" size="16" :color="silentBottomListSound ? '#ff0000' : '#464646'"
                            @click="handleAlarmBottomListManual()" v-bind="attrs" v-on="on">
                            {{ silentBottomListSound ? 'mdi-bell-off-outline' : 'mdi-bell-outline' }}
                          </v-icon>
                        </template>
                        <span>{{ silentBottomListSound ? 'صدای هشدار خاموش' : 'صدای هشدار روشن' }}</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" :class="{ 'refresh-btn': bottomListManualRefreshLoaderFlag }"
                            v-bind="attrs" v-on="on" @click="refreshBottomListManual()">
                            mdi-cached mdi-18px
                          </v-icon>
                        </template>
                        <span>به روز رسانی</span>
                      </v-tooltip>
                      ماموریت های جاری (
                      {{ bottomListFilterList.length }} )
                    </span>
                  </div>
                  <div class=" itemBtn item2">
                    <v-text-field hide-details rounded placeholder="کد" outlined v-model="searchTextCode" dense
                      class="current-mission-text-field"></v-text-field>
                  </div>
                  <div class=" itemBtn item4">
                    <v-text-field hide-details rounded placeholder="جستجو..." outlined
                      v-model="currentMissionSearchText" dense class="current-mission-text-field"></v-text-field>
                  </div>
                  <div class=" itemBtn item3">
                    <v-autocomplete hide-details :items="allZones" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                      rounded item-text="title" item-value="value" clearable clear-icon="mdi-close mdi-18px"
                      append-icon="" multiple placeholder="ناحیه" autocomplete="off" class="current-mission-select"
                      v-model="selectedZone" :menu-props="{ contentClass: 'zone-autocomplete-menu' }"></v-autocomplete>
                  </div>
                </div>
                <!-- bottom table -->
                <template>
                  <v-data-table id="bottomTable2" fixed-header :defaultHeaders="bottomListTableHeader"
                    :cell-props="({ header }) => ({ style: { width: header.width, minWidth: header.width } })"
                    :headers="currentHeaders.filter(h => h.isActive !== false)" :items="bottomListFilterList"
                    :items-per-page="bottomListFilterList.length" :height="bottomTableHight" dense
                    loading-text="به روزرسانی.... لطفا منتظر بمانید" :hide-default-footer="true" multi-sort
                    :item-class="(item) => `${selectedRow === item?.id ? 'heighlighted-row' : ''}`"
                    class="elevation-0 bottomTable" :search="currentMissionSearchText" @dblclick:row="showEditModal"
                    @contextmenu:row="onContextClick" @click:row="invokeToCodeInMap">
                    <!--                    v-sortable-table="{
                      onEnd: sortTheHeadersAndUpdateTheKey,
                      active: false,
                    }"
                    :key="anIncreasingNumber"-->
                    <template v-slot:[`item.icon`]="{ item }">
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="4" v-for="(data, index9) in item.iconData" :key="'jkj' + index9">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon @click="handleClickIconStatus(item.toopakId, data)" :color="data.color"
                                    v-bind="attrs" v-on="on">
                                    {{ data.icon }}
                                  </v-icon>
                                </template>
                                <span>{{ data.text }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                      <v-row dir="rtl" v-if="item.hasAddressChanged == true" class="bottom-list-address" no-gutters>
                        <v-col cols="12" class="text-right pr-2">
                          <div class="my-row">
                            <v-col class="bottom-list-change-address-space2" v-if="item.hasUnsentAddressNotification">
                              <v-icon class="ml-n5 mt-n1" color="#FF9C78">mdi-circle-medium</v-icon>
                            </v-col>
                            <v-col class="bottom-list-change-address-space" v-if="item.hasUnsentAddressNotification">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col class="bottom-list-change-address-space3" v-else>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1 pr-2">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasAddressChanged == false" no-gutters dir="rtl">
                        <v-col cols="12" class="text-right pr-2">
                          <div class="my-row items-center">
                            <v-col class="bottom-list-change-address-space2" v-if="item.hasUnsentAddressNotification">
                              <v-icon class="ml-6" color="#FF9C78">mdi-circle-medium</v-icon>
                            </v-col>
                            <v-col class="bottom-list-change-address-space" v-if="item.hasUnsentAddressNotification">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col class="bottom-list-change-address-space3" v-else>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.cc`]="{ item }">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-right">
                          <div dir="rtl" class="flex items-center justify-start gap-1">
                            <v-icon :color="item.rankIconColor">
                              mdi-numeric-{{ item?.patientsCount }}-circle
                            </v-icon>
                            <v-icon v-if="item.hasUnsentCcNotification" color="#FF9C78">
                              mdi-circle-medium
                            </v-icon>
                            <div class="line-clamp-1">
                              {{ item.cc }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.hospital`]="{ item }">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-right">
                          <div class="flex items-center gap-1">
                            <v-icon v-if="item.hasUnsentHospitalNotification" color="#FF9C78">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.hospital ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.user`]="{ item }">
                      <app-wrap-text :text="item?.user ?? ''" />
                    </template>
                    <template v-slot:[`item.zone`]="{ item }">
                      <app-wrap-text :text="item?.zone ?? ''" />
                    </template>
                    <template v-slot:[`item.ambulanceCode`]="{ item }">
                      <v-row v-if="item.hasLackOfCode == true && item.status != '10-24 موقت'"
                        class="bottom-list-lake-off-code" no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>فاقدی</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == true && item.status == '10-24 موقت'" class="bottom-list-1024"
                        no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == false && item.status == '10-24 موقت'" class="bottom-list-1024"
                        no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == false && item.status != '10-24 موقت'" no-gutters>
                        <v-col cols="12" class="text-center">
                          <div v-bind="attrs" v-on="on" class="flex items-center">
                            <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                              {{ item.recivedToPhoneState }}
                            </v-icon>
                            <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.shabrangCode`]="{ item }">
                      <v-row v-if="item.status == '10-24 موقت'" class="bottom-list-1024" no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <app-wrap-text v-bind="attrs" :text="item?.shabrangCode ?? ''" v-on="on"></app-wrap-text>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.status != '10-24 موقت'" no-gutters>
                        <v-col cols="12" class="text-center">
                          <app-wrap-text :text="item?.shabrangCode ?? ''" />
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.phoneNumber`]="{ item }">
                      <app-wrap-text :text="item?.phoneNumber ?? ''" />
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <v-row v-if="item.status == '10-33'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status == '10-99'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('10-19')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('724')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('247')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status == '10-12'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.startsWith('بیمارستان')" class="bottom-list-status-10-99"
                        no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else no-gutters>
                        <v-col cols="12" class="text-right">
                          <div class="flex items-baseline gap-1">
                            <div>
                              <v-icon v-if="item.hasUnsentStateNotification" color="#FF9C78">
                                mdi-circle-medium
                              </v-icon>
                            </div>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.phoneStatus`]="{ item }">
                      <v-row v-if="item.markPhoneCurrentState" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <app-wrap-text :text="item?.phoneStatus ?? ''" />
                        </v-col>
                      </v-row>
                      <v-row v-else no-gutters>
                        <v-col cols="12" class="text-right">
                          <app-wrap-text :text="item?.phoneStatus ?? ''" />
                        </v-col>
                      </v-row>
                    </template>


                    <template v-slot:[`item.ccNote`]="{ item }">
                      <td><app-wrap-text :text="item?.ccNote ?? ''" /></td>
                    </template>
                    <template v-slot:[`item.chiefComplaintText`]="{ item }">
                      <td><app-wrap-text :text="item?.chiefComplaintText ?? ''" /></td>
                    </template>
                    <template v-slot:[`item.phonePreviousState`]="{ item }">
                      <td>
                        <app-wrap-text :text="item?.phonePreviousState ?? ''" />
                      </td>
                    </template>
                    <template v-slot:[`item.ambulanceStatus`]="{ item }">
                      <td><app-wrap-text :text="item?.ambulanceStatus ?? ''" /></td>
                    </template>
                    <template v-slot:no-data>
                      <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                    </template>
                  </v-data-table>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute :close-on-content-click="closeOnContentClick"
      offset-y>
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index10) in visibleRightClickItems" :key="'qq' + index10" dense
            @click="handelSelectMenu(item)">
            <v-list-item-icon>
              <v-icon color="darkColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="item.title == 'اعزام کد مجدد'" class="mr-n5">
              <v-list-item-title class="text--white menu-items">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content v-if="item.title == 'درخواست موقعیت'" class="mr-n5">
              <v-list-item-title class="text--white menu-items">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content v-if="item.title == '10-24 موقت'" class="mr-n5">
              <v-list-item-title class="text--white menu-items">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس داخلی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field label="شماره تماس" dense v-model="iternalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس خارجی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field placeholder="شماره تماس" dense small v-model="externalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone-forward mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با کد'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item @click="rightClickAction(item.title, codePhoneNumbers)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ codePhoneNumbers }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با مددجو'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in patientPhoneNumbers" :key="'c' + index"
                  @click="rightClickAction(item.title, sitem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با ارگان'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in allOtherOrganizationsForOther" :key="'o' + index"
                  @click="rightClickAction(item.title, sitem?.phoneNumber)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem?.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با بیمارستان'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in hospitalPhoneNumbers" :key="'h' + index"
                  @click="rightClickAction(item.title, sitem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-row no-gutters>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-3 mb-2 mr-6 ml-3">
          <v-icon class="ml-3" :color="color.color" v-for="color in colorTags" :key="color.id"
            @click="setToopackForMission(color)">
            mdi-circle
          </v-icon>
        </v-row>
      </v-list>
    </v-menu>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) {
            mutation.target.classList.add('sortHandle');
          }
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}
import Sortable from 'sortablejs';
import throttle from 'lodash/throttle';
import { latLng } from 'leaflet';
import L from 'leaflet';
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LPopup,
  LTooltip,
  LControl,

  // LIcon,
} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import NewMissionStatus from '@/components/800/missionsView/newMissionStatus.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import Edit800MissionComponent from '../../components/800/Edit800MissionComponent.vue';
import ColumnManagerDialog from '../../components/800/ColumnManagerDialog.vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AppWrapText from '@/components/app/wrapText.vue';
import TerminehModal from '@/components/800/missionsView/termineh.modal.vue';
// ------------option-api--------------------
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import Mission800Helper from '@/Helpers/800/800MissionHelper.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionLackOFCodeMixin from '@/Mixins/Mission/MissionLackOfCodeMixin.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import CancelReasonMixin from '@/Mixins/BaseInformation/CancelReasonMixin';
import StationCoverageZoneMixin from '@/Mixins/BaseInformation/StationCoverageZoneMixin';
import MapMixin from '@/Mixins/115/MapMixin.js';
import SharedMap from '@/Mixins/map';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import UserGridSettingsMixin from '@/Mixins/BaseInformation/UserGridSettingsMixin.js';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import missionOtherOrganizationRequestMixin from '@/Mixins/Mission/MissionOtherOrganizationRequestMixin.js';
import missionOtherOrganizationInformMixin from '@/Mixins/Mission/MissionOtherOrganizationInformMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import TerminehMixin from '@/Mixins/800/termineh.mixin';
import MapSearchField from '@/components/app/map/search.vue';
import SerachMapMixin from '@/components/app/map/SerachMapMixin.js';
import '@/assets/styles/800.scss';
import Vue from 'vue';

export default {
  name: 'Mission800View',
  directives: {
    'sortable-table': {
      inserted: (el, binding) => {
        el.querySelectorAll('th').forEach((draggableEl) => {
          watchClass(draggableEl, 'sortHandle');
          draggableEl.classList.add('sortHandle');
        });
        Sortable.create(
          el.querySelector('tr'),
          binding.value ? { ...binding.value, handle: '.sortHandle' } : {},
        );
      },
    },
  },
  title: 'ماموریت های جاری 800',
  inject: ['load'],
  components: {
    AlertComponent,
    Edit800MissionComponent,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    'v-popup': LPopup,
    LTooltip,
    AppWrapText,
    LControl,
    confirmDialog,
    NewMissionStatus,
    TerminehModal,
    MapSearchField,
    ColumnManagerDialog
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    Mission800Helper,
    MissionMixin,
    PhoneMixin,
    StationMixin,
    MissionLackOFCodeMixin,
    MissionPhonesMixin,
    CancelReasonMixin,
    StationCoverageZoneMixin,
    MapMixin,
    ZoneMixin,
    DispatchCodeMixin,
    PhoneOnlineLocationMixin,
    CallMixin,
    missionOtherOrganizationRequestMixin,
    missionOtherOrganizationInformMixin,
    OtherOrganizationMixin,
    UserNotificationMixin,
    SharedMap,
    TerminehMixin,
    SerachMapMixin,
    UserGridSettingsMixin
  ],
  created() {
    this.$root.$refs.Mission800View = this;

    // ///////
    // const saved = localStorage.getItem('bottomTableHeaders');
    // if (saved) {
    //   try {
    //     this.currentHeaders = JSON.parse(saved);
    //   } catch (e) {
    //     this.currentHeaders = [...this.bottomListTableHeader];
    //   }
    // } else {
    this.currentHeaders = [...this.bottomListTableHeader];
    // }

    // ////////

    this.throttledMainList800 = throttle(this.fMainList800, 1500, {
      leading: true,
      trailing: true,
    });

    this.throttledTopList800 = throttle(this.fTopList800, 1500, {
      leading: true,
      trailing: true,
    });

    this.throttledNewMissionList800 = throttle(this.fNewMission800, 1500, {
      leading: true,
      trailing: true,
    });

    this.throttledBottomListSound = throttle(() => {
      if (!this.silentBottomListSound) {
        this.playSound800BottomList();
      }
    }, 5000, { leading: true, trailing: false });

    this.$mainSignalr.bus.$on('MainList800', this.throttledMainList800);
    this.$mobileSignalr.bus.$on('MainList800', this.throttledMainList800);
    this.$mainSignalr.bus.$on('NewMission800', this.throttledNewMissionList800);
    this.$mobileSignalr.bus.$on('NewMission800', this.throttledNewMissionList800);
    this.$mainSignalr.bus.$on('TopList800', this.throttledTopList800);
    this.$mobileSignalr.bus.$on('TopList800', this.throttledTopList800);
    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  mounted() {
    this.mounteLoding();
    // this.onScroll();
    // this.bottomListFilterList();
    this.getSystemSettingByClientComputer();
    this.setMapBaseSystemSetting();
    this.loadVoicesFromStorage();
    window.addEventListener('keydown', this.handleFunctionKeys);
  },
  data() {
    return {
      showColumnManager: false,
      currentHeaders: [],
      searchTextCode: '',
      searchTextCode_Attach: '',
      silentTopListSound_A: false,
      silentBottomListSound_A: false,
      clickItem: null,
      tempvalue: null,
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      dragging: false,
      icon: this.getIcon,
      patientIcon: L.divIcon({
        // @/assets/images/mapMarkerRadius.svg
        html: `<div class="map-icon-ripple"></div>
        <img src="${require('@/assets/images/mapMarkerRadius.svg')}" alt="patient-marker"/>`,
        className: 'map-icon-container',
        iconSize: [30, 30],
        iconAnchor: [0, 0],
      }),
      bottomTableHight: '50vh',
      topTableHight: '24vh',
      bottomListRefreshInFlight: false,
      bottomListRefreshPending: false,
      topListRefreshInFlight: false,
      topListRefreshPending: false,

    };
  },
  beforeDestroy() {
    // this.closeNewTabByHref('/800/map')
    window.removeEventListener('keydown', this.handleFunctionKeys);
    this.clearSoundInterval();
    this.cleanupResources();

    this.$mainSignalr.bus.$off('MainList800', this.throttledMainList800);
    this.$mobileSignalr.bus.$off('MainList800', this.throttledMainList800);
    this.$mainSignalr.bus.$off('NewMission800', this.throttledNewMissionList800);
    this.$mobileSignalr.bus.$off('NewMission800', this.throttledNewMissionList800);
    this.$mainSignalr.bus.$off('TopList800', this.throttledTopList800);
    this.$mobileSignalr.bus.$off('TopList800', this.throttledTopList800);
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    this.throttledMainList800.cancel();
    this.throttledTopList800.cancel();
    this.throttledNewMissionList800.cancel();
    this.throttledBottomListSound.cancel();

    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
      this.stickyObserver = null;
    }

    delete this.$root.$refs.Mission800View;
  },
  methods: {
    getRealColumnWidths() {
      const table = document.querySelector('#bottomTable2 table');
      if (!table) {
        return null;
      }

      const headerCells = table.querySelectorAll('thead tr th');
      if (!headerCells.length) {
        return null;
      }

      const widths = [];
      headerCells.forEach((th) => {
        const width = th.getBoundingClientRect().width;
        widths.push(Math.round(width));
      });
      return widths;
    },

    openColumnManager() {
      const realWidths = this.getRealColumnWidths();

      if (realWidths) {
        const headersWithWidth = this.currentHeaders.map((h, index) => ({
          ...h,
          width: realWidths[index] ? realWidths[index] : (h.width || 120),
        }));

        this.currentHeaders = headersWithWidth;
      }

      this.showColumnManager = true;
      const icon = document.getElementById('iconDatabase');
      if (icon) icon.blur();
    },
    applyNewHeaders(newHeaders) {
      this.currentHeaders = newHeaders;
      this.setUserGridSettingFunction({
        gridName: "BottomList800",
        settingsJson: JSON.stringify(newHeaders)
      })
      // localStorage.setItem('bottomTableHeaders', JSON.stringify(newHeaders));
    },
    openAttachmentModal() {
      this.searchTextCode_Attach = '';
      this.showCurrentMissionAttachmentModal();
    },
    startsWithFilter(item, queryText, itemText) {
      return itemText.toLowerCase().startsWith(queryText.toLowerCase())
    },
    handelSelectMenu(item) {
      if (item.title == 'اعزام کد مجدد') {
        this.rightClickAction(item.title, null)
      } else if (item.title == 'درخواست موقعیت') {
        this.rightClickAction(item.title, null)
      } else if (item.title == '10-24 موقت') {
        this.showConfirmDialogFor10_24()
      }


    },
    handleAlarmTopListManual() {
      this.topListSoundStop = true;
      this.silentTopListSound = !this.silentTopListSound;
    },
    handleAlarmBottomListManual() {
      this.silentBottomListSound = !this.silentBottomListSound;
    },
    shouldShowSpecialStatus(status) {
      const hasAnyItem = this.specialStatuses.some(item => status?.includes(item));

      return hasAnyItem ||
        status?.includes("استقرار") ||
        status?.startsWith("بیمارستان") ||
        status === "درخواست کد سما";
    },
    handleFunctionKeys(e) {
      const keyActions = {
        F9: () => this.handleSubmitForms(),
      };

      if (keyActions[e.key] && this.sendTOPhoneModal) {
        e.preventDefault();
        keyActions[e.key]();
      }
    },
    handleSubmitForms() {
      if (this.sendModalType === 'main') {
        this.sendMissionToPhoneCheckType();
      } else {
        this.sendToOtherCodeConfirmation();
      }
    },
    handleEnterLack() {
      this.$nextTick(() => {
        if (this.selectedMissionLakeCode) {
          this.addMissionLakeCode();
        }
      });
    },
    sortTheHeadersAndUpdateTheKey(evt) {
      const headersTmp = this.bottomListTableHeader;
      const oldIndex = evt.oldIndex;
      const newIndex = evt.newIndex;
      if (newIndex >= headersTmp.length) {
        let k = newIndex - headersTmp.length + 1;
        while (k--) {
          headersTmp.push(undefined);
        }
      }
      headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
      this.table = headersTmp;
      this.anIncreasingNumber += 1;
      setTimeout(() => {
        var mtable = document.getElementsByTagName('table');
        this.resizableGrid(mtable[1]);
      }, 700);
    },
    mounte: function async() {
      var tables = document.getElementsByTagName('table');
      this.resizableGrid(tables[1]);

      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });

      this.getAllUserGridSettingsFunction('BottomList800').then((resolve) => {

        if (resolve?.length > 0) {
          let temp = resolve?.find((item) => item?.gridName == 'BottomList800');
          if (temp?.settingsJson) {
            try {
              this.currentHeaders = JSON.parse(temp?.settingsJson);
            } catch (e) {
              this.currentHeaders = [...this.bottomListTableHeader];
            }
          } else {
            this.currentHeaders = [...this.bottomListTableHeader];
          }
        } else {
          this.currentHeaders = [...this.bottomListTableHeader];
        }
        this.onScroll();
      });


      this.refreshTopList(true, true)
      this.refreshBottomList();
      this.getListOfOtherOrganizationsForOther();
      this.getAllZones();
      this.onScroll();
      this.getAllUniversities();
      if (screen.height <= 728) {
        this.bottomTableHight = '48vh';
        this.topTableHight = '23vh';
      } else if (screen.height >= 850) {
        this.bottomTableHight = '57vh';
        this.topTableHight = '24vh';
      }
      else if (screen.height >= 800) {
        this.bottomTableHight = '55vh';
        this.topTableHight = '24vh';
      }
      else if (screen.height >= 750) {
        this.bottomTableHight = '54vh';
        this.topTableHight = '24vh';
      } else {
        this.bottomTableHight = '50vh';
        this.topTableHight = '24vh';
      }
    },
    getData: function () {
      this.refreshTopList(true, false)
    },
    fMainList800: function () {
      this.throttledBottomListSound();
      this.refreshBottomList();
    },

    refreshBottomList: async function () {
      if (this.bottomListRefreshInFlight) {
        this.bottomListRefreshPending = true;
        return;
      }
      this.bottomListRefreshInFlight = true;
      try {

        await this.getListOfDispatchBottomListFunction();
      } catch (error) {
        console.log('refreshBottomList error:', error);
      } finally {
        this.bottomListRefreshInFlight = false;
        if (this.bottomListRefreshPending) {
          this.bottomListRefreshPending = false;
          this.refreshBottomList();
        }
      }
    },

    fTopList800: function () {
      if (!this.silentTopListSound) {
        this.playSound3();
      }
      this.refreshTopList(false, false);
    },
    fNewMission800: function () {
      this.topListSoundStop = this.silentTopListSound;
      this.refreshTopList(true, false)
    },

    refreshTopList: async function (needSound, needRefresh) {
      if (this.topListRefreshInFlight) {
        this.topListRefreshPending = true;
        return;
      }
      this.topListRefreshInFlight = true;
      try {
        await this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
      } catch (error) {
        console.log('refreshTopList error:', error);
      } finally {
        this.topListRefreshInFlight = false;
        if (this.topListRefreshPending) {
          this.topListRefreshPending = false;
          this.refreshTopList(needSound, needRefresh);
        }
      }
    },

    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
    onGetAllUserNotificationOnSignal: function () {
      this.getAllUserNotificationsOnSignal();
    },
    invokeToCodeInMap: function (value, data) {
      this.selectedRow = data.item?.id;
      this.clickItem = value;
      const connection = Vue.prototype.$mainSignalr?.connection;
      if (!connection || connection.state !== 'Connected') {
        console.warn('[SignalR2] connection not ready');
        return;
      }
      connection.invoke('Location', data.item.ambulanceCode.toString()).catch((err) => {
        console.error('[SignalR2] invoke Location failed:', err);
      });
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },

    onScroll() {
      const table = document.querySelectorAll('.v-data-table')[1]?.children[0];
      if (!table) return;

      const paintRow = (row, color) => {
        if (!row || !row.children || !row.children[14]) return;
        row.children[14].style.backgroundColor = color;
        row.children[13].style.backgroundColor = color;
      };

      table.addEventListener('click', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('contextmenu', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('mouseover', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('mouseout', (e) => {
        const row = e.target.closest('tr');
        if (!row) return;
        const isSelected = [...row.classList].some((c) => c === 'heighlighted-row');
        paintRow(row, isSelected ? '#cbcbcb' : 'white');
      });

      let stickyTicking = false;
      const scheduleSticky = () => {
        if (stickyTicking) return;
        stickyTicking = true;
        requestAnimationFrame(() => {
          stickyTicking = false;
          applySticky(table);
        });
      };

      table.addEventListener('scroll', scheduleSticky);

      this.stickyObserver?.disconnect();
      this.stickyObserver = new MutationObserver(scheduleSticky);
      this.stickyObserver.observe(table, { childList: true, subtree: true });

      scheduleSticky();

      function applySticky(target) {
        const ths = target.querySelectorAll('th');
        const secondCol = ths[13];
        const firstCol = ths[14];
        if (!secondCol || !firstCol) return;
        const maxScrollLeftValue = target.scrollWidth - target.clientWidth;
        const stickyOn = maxScrollLeftValue > target.scrollLeft;

        if (stickyOn) {
          secondCol.style.position = 'sticky';
          secondCol.style.right = `${firstCol.offsetWidth}px`;
          secondCol.style.backgroundColor = 'white';
          secondCol.style.borderLeft = '1px solid #212121';
        } else {
          secondCol.style.position = 'relative';
          secondCol.style.left = '0px';
          secondCol.style.borderLeft = 'none';
        }

        const rows = target.querySelectorAll('tr');
        rows.forEach((row) => {
          const secondTd = row.querySelectorAll('td')[13];
          const firstTd = row.querySelectorAll('td')[14];
          if (!secondTd || !secondTd.style) return;
          const isSelected = [...row.classList].some((c) => c === 'heighlighted-row');

          if (stickyOn) {
            secondTd.style.position = 'sticky';
            secondTd.style.right = `${firstCol.offsetWidth}px`;
            secondTd.style.borderLeft = '1px solid #212121';
            secondTd.style.backgroundColor = isSelected ? '#cbcbcb' : 'white';
            if (firstTd && firstTd.style) {
              firstTd.style.backgroundColor = isSelected ? '#cbcbcb' : 'white';
            }
          } else {
            secondTd.style.position = 'relative';
            secondTd.style.right = '0px';
            secondTd.style.borderLeft = 'none';
            secondTd.style.backgroundColor = 'transparent';
          }
        });
      }
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      if (data.speed >= 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        }
      }
    },
    resizableGrid: function (table) {
      const element = document.getElementsByClassName('v-data-table__wrapper')[1];
      element.scrollLeft += element.scrollWidth;
      var row = table.getElementsByTagName('tr')[0],
        cols = row ? row.children : undefined;
      if (!cols) return;
      table.style.overflow = 'scroll';
      table.style.tableLayout = 'fixed';

      var tableHeight = table.offsetHeight;

      var drag = { curCol: null, pageX: 0, curColWidth: 0, tableStartWidth: 0, delta: 0 };

      for (var p = 0; p < cols.length; p++) {
        cols[p].style.width = (cols[p].offsetWidth - paddingDiff(cols[p])) + 'px';
      }

      for (var i = 0; i < cols.length; i++) {
        var div = createDiv(tableHeight);
        cols[i].appendChild(div);
        cols[i].style.position = 'relative';
        setListeners(div);
      }

      function onMouseMove(e) {
        if (!drag.curCol) return;
        var diffX = e.pageX - drag.pageX;
        var newWidth = Math.max(40, drag.curColWidth - diffX);
        drag.delta = newWidth - drag.curColWidth;

        drag.curCol.style.width = newWidth + 'px';
        table.style.width = (drag.tableStartWidth + drag.delta) + 'px';

        if (drag.wrapperIsRtl) {
          drag.wrapper.scrollLeft = drag.wrapperStartScroll - drag.delta;
        } else {
          table.style.marginLeft = (-drag.delta) + 'px';
        }
      }

      function onMouseUp() {
        if (drag.curCol && !drag.wrapperIsRtl && drag.delta) {
          table.style.marginLeft = '';
          drag.wrapper.scrollLeft = Math.max(0, drag.wrapperStartScroll + drag.delta);
        }
        drag.curCol = null;
        drag.delta = 0;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      function setListeners(div) {
        div.addEventListener('mousedown', function (e) {
          e.preventDefault();
          drag.curCol = e.target.parentElement;
          drag.pageX = e.pageX;
          drag.delta = 0;
          drag.curColWidth = drag.curCol.offsetWidth - paddingDiff(drag.curCol);
          drag.tableStartWidth = table.offsetWidth;

          drag.wrapper = table.closest('.v-data-table__wrapper') || element;
          drag.wrapperIsRtl = getStyleVal(drag.wrapper, 'direction') === 'rtl';
          drag.wrapperStartScroll = drag.wrapper.scrollLeft;

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

        div.addEventListener('mouseover', function (e) {
          e.target.style.borderLeft = '2px solid #0000ff';
        });

        div.addEventListener('mouseout', function (e) {
          e.target.style.borderLeft = '';
        });
      }

      function createDiv(height) {
        var div = document.createElement('div');
        div.style.top = 0;
        div.style.left = 0;
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = height + 'px';
        return div;
      }

      function paddingDiff(col) {
        if (getStyleVal(col, 'box-sizing') == 'border-box') {
          return 0;
        }

        var padLeft = getStyleVal(col, 'padding-left');
        var padRight = getStyleVal(col, 'padding-right');
        return parseInt(padLeft) + parseInt(padRight);
      }
      function getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
      }
    },
  },
  computed: {
    visibleRightClickItems() {
      return this.rightClickItems.filter(item => {
        if (item.title === 'تماس با بیمارستان') {
          return this.hospitalPhoneNumbers?.length > 0;
        }
        return true;
      });
    },
    silentTopListSound: {
      get() {
        return this.silentTopListSound_A;
      },
      set(value) {
        this.silentTopListSound_A = value;
      }
    },
    silentBottomListSound: {
      get() {
        return this.silentBottomListSound_A;
      },
      set(value) {
        this.silentBottomListSound_A = value;
      }
    },
    specialStatuses() {
      const fixed = ["10-33", "10-99", "10-19", "10-12", "10-51", "10-10", "10-63", "10-60", "10-7", "10-24"];
      const apiTitles = this.allOtherOrganizationsForOther?.map(item => item.title);
      return [...fixed, ...apiTitles];
    },
    //Voice
    formattedTime() {
      const mins = Math.floor(this.recordingSeconds / 60);
      const secs = this.recordingSeconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    bottomListFilterList() {
      const zones = [...this.selectedZone];
      const list = [...this.filteredBottomList];

      let result = [];

      if (zones.length === 0) {
        result = list;
      } else {
        const zoneSet = new Set(zones);
        result = list.filter((u) => {
          return zoneSet.has(u.zone) || zones.some(zone => u.zone?.includes(zone));
        });
      }
      if (this.searchTextCode && this.searchTextCode.trim() !== '') {
        const searchLower = this.searchTextCode.toLowerCase().trim();
        result = result.filter((u) => {
          return (
            u.ambulanceCode?.toLowerCase().includes(searchLower) ||
            u.shabrangCode?.toLowerCase().includes(searchLower)
          );
        });
      }

      return result;
    },
    attachallFilterList() {
      const list = [...this.allAttachment];
      let result = list;

      if (this.searchTextCode_Attach && this.searchTextCode_Attach.trim() !== '') {
        const searchLower = this.searchTextCode_Attach.toLowerCase().trim();
        result = result.filter((u) => {
          return (u.code?.toLowerCase().includes(searchLower));
        });
      }

      return result;
    }
  },
  watch: {
    patiantPosition: function (value) {
      this.$refs.modalmap.mapObject?.flyTo(value, 16);
    },
    currentMissionSearchText() {
      this.$nextTick(() => {
        const wrapper = document.querySelector('#bottomTable2 .v-data-table__wrapper');
        if (wrapper) wrapper.scrollTop = 0;
      });
    }
  },
};
</script>
<style lang="scss">
.btnContolerBottomList {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-top: -32px;
  margin-bottom: 8px;

  .itemBtn {
    display: flex;
    justify-content: center;
    align-items: center;

    &.item2 {
      max-width: 150px;
    }

    &.item3 {
      min-width: 400px;
      margin-right: 10px;
    }

    &.item4 {
      margin-right: auto;
    }

    .blue-text-btn {
      background-color: #dde4ff !important;
      color: var(--dark-color) !important;
      border: 1px solid var(--dark-color) !important;
    }

    .blue-text-btn .v-icon {
      color: var(--dark-color) !important;
    }

    .blue-text-btn:hover {
      background-color: #f5f5f5 !important;
    }
  }
}

.btnImmigration {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: auto;

  >button {
    background: var(--v-darkColor-base);
    border-radius: 8px;
    color: white;
    font-size: 14px;
    font-weight: 400;
    padding: 4px 12px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    margin-right: auto;

    &:hover {
      opacity: 0.9;
      box-shadow: 2px 2px 7px 2px #0000004e;
    }
  }
}

.voiceDialog {
  .t1 {
    font-size: 17px !important;
    font-weight: 500;
  }

  .t2 {
    font-size: 15px !important;
    font-weight: 500;
  }
}

.refresh-btn {
  animation-name: spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.mission_view_800 {

  span,
  div,
  td {
    div {
      -webkit-user-select: none !important;
      /* Safari */
      -ms-user-select: none !important;
      /* IE 10 and IE 11 */
      user-select: none !important;
      /* Standard syntax */
    }
  }
}

#topTable {
  thead {
    tr {
      z-index: 1 !important;
    }
  }
}

.cancel-style {
  background: #ff9c78 !important;

  td {
    background: #ff9c78 !important;
  }

  color: white;
}

#bottomTable2 {
  thead {
    tr {
      z-index: 1 !important;
    }

    th:last-of-type {
      position: sticky !important;
      background-color: white;
      right: 0;
    }
  }

  tbody {
    td:last-of-type {
      position: sticky;
      right: 0;
      background-color: white;
    }
  }
}

.freezCol {
  position: sticky;
  background-color: white;
  right: 90px;
}

.heighlighted-row {
  background-color: #cbcbcb !important;
  color: white !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
<style scoped>
>>>.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 6px !important;
}

>>>.bottomTable .v-data-table__wrapper table {
  table-layout: fixed;
}

/* //Voice */
.recording-indicator {
  padding: 16px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.recording-indicator.is-recording {
  animation: pulse 1.5s infinite;
  background-color: rgba(255, 0, 0, 0.1);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }

  70% {
    box-shadow: 0 0 0 15px rgba(255, 0, 0, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

/* //Voice  */
.mission-800-list-card {
  border: 1px solid var(--dark-color) !important;
  background: white !important;
}

.current-mission-header-content {
  font-size: 13px;
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.covered-position {
  margin-top: -25px !important;
}

.covered-position2 {
  margin-top: -30px !important;
}

.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.x-overflow {
  overflow-x: auto !important;
}

.send-mission-detail-card {
  border: 1px solid var(--dark-color) !important;
}

.send-mission-detail-card-body {
  height: 10vh !important;
  overflow-y: auto !important;
}

.send-mission-title-content {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 11px;
  background: white !important;
  margin-top: -1.5vh !important;
  margin-right: 2vh !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.send-mission-title-content2 {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 13px;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 500;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.missionSendInfo-diagnosis-title {
  max-width: 120px;
}

.mission-card-header-rank-title {
  font-weight: 500;
  font-size: 14px;
  color: #212121 !important;
}

.mission-card-header-rank-text {
  font-weight: 400;
  font-size: 13px;
  color: #212121 !important;
}

.bottom-bar {
  position: absolute !important;
  top: 100% !important;
}

.map-popup {
  width: 70px !important;
  overflow-x: hidden !important;
}

.popup-items-content {
  font-size: 12px !important;
}

>>>.current-mission-text-field fieldset {
  background: white !important;
}

>>>.current-mission-select fieldset {
  background: white !important;
}

.right-click-menu-title {
  font-size: 12px !important;
}

.bottom-list-address {
  background: #9fe2ff !important;
  border-radius: 5px !important;
  /*height: 70% !important;
  max-height: 70% !important;
  min-height: 70% !important;*/
}

.bottom-list-lake-off-code {
  background: #f8eaff !important;
  border-radius: 5px !important;
}

.bottom-list-1024 {
  background: #cacaca !important;
  border-radius: 5px !important;
}

.bottom-list-status-10-99 {
  background: #ff9c78 !important;
  border-radius: 5px !important;
  color: white;
}

.bottom-list-status-10-33 {
  background: #ffd89b !important;
  border-radius: 5px !important;
}

.rank-icon-anim1 {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

.rank-icon-anim2 {
  animation: shake2 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes shake2 {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(5deg);
  }

  50% {
    transform: rotate(0deg);
  }

  75% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

>>>.bottomTable.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.bottomTable .v-data-table__wrapper table {
  /* margin-left: auto !important; */
  min-width: 100% !important;
}

>>>.bottomTable .v-data-table__wrapper table tbody tr td {
  font-size: 14px !important;
  font-weight: 600 !important;
}

>>>.bottomTable .v-data-table-header tr th {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: black !important;
}

>>>.top-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.top-table .v-data-table__wrapper table tbody tr td {
  font-size: 14px !important;
  font-weight: 600 !important;
}

>>>.top-table .v-data-table-header tr th {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: black !important;
}

>>>.current-mission-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.current-mission-text-field.v-input input {
  max-height: 30px !important;
}

>>>.current-mission-select .v-input__control .v-input__slot {
  min-height: 15px !important;
  max-height: 30px !important;
  font-size: 10px !important;
}

>>>.current-mission-select.v-input input {
  min-height: 15px !important;
  max-height: 30px !important;
  font-size: 10px !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.other-organ-selected-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.other-organ-sugest-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
}

.other-organ-sugest-user {
  position: absolute;
  margin-top: -12px;
  margin-right: 24px;
  padding-left: 8px;
  padding-right: 5px;
  background: white;
  font-size: 12px;
}

.other-organ-selected-span {
  background: var(--background-color) !important;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 30px !important;
  font-size: 12px;
}

>>>.bottomTable th {
  border-right: 1px solid grey !important;
}

>>>.bottomTable td {
  border-right: 1px solid grey !important;
}

>>>.table-top-800 td {
  border-right: 1px solid grey !important;
}

>>>.table-top-800 th {
  border-right: 1px solid grey !important;
}

/*>>> td {
  border-right: 1px solid grey !important;
}*/
.bottomTable>>>.v-data-table__wrapper {
  direction: ltr;
}

.bottom-list-change-address-space {
  width: 92%;
  min-width: 92%;
  max-width: 92%;
  padding: 0px !important;
}

.bottom-list-change-address-space3 {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding: 0px !important;
}

.bottom-list-change-address-space2 {
  width: 8%;
  min-width: 8%;
  max-width: 8%;
  padding: 0px !important;
}

.my-row {
  display: flex !important;
  flex-wrap: wrap !important;
  margin: 0px !important;
  align-items: center;
  padding: 0px !important;
}

>>>.truncate {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>>.truncate2 {
  display: inline-block;
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>>th {
  position: sticky !important;
  top: 0 !important;
}

.custom-autocomplete-item .item-code {
  font-weight: 600;
  color: #000029;
  margin-left: 8px;
  font-size: 16px;
  unicode-bidi: embed;
  direction: ltr;
}
</style>
<style>
.zone-autocomplete-menu .v-list-item {
  min-height: 35px !important;
}

.zone-autocomplete-menu .v-list-item__action {
  margin: 2px 0px 4px 2px !important;
}
</style>